import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {  PatchTramRegistroObservaciones
} from '../../../shared/interfaces/database/tramite';
import {QueryParam, Utils} from "lib-base";
import {
  IGetActividadesPendienteAsignacion,
  IGetSolicitudesByMes,
  IGetSolicitudesGlobales,
  IGetSolicitudesPorTipoPqrsd
} from "../../../shared/interfaces/database/pqrsd";

/**
 * Interfaz para el DTO de observaciones para rechazar solicitudes
 */
export interface PatchTramRegistroObservacionesDto {
  observaciones: string;
}

@Injectable({
  providedIn: 'root'
})
export class SolicitudService {
  // URL base para las operaciones de solicitudes PQRSD
  private readonly apiUrl = `${environment.apiUrl}/api/pqrsd/solicitudes`;

  constructor(private readonly http: HttpClient) {}

  rechazarSolicitud(solicitudId: number, observaciones: string): Observable<string> {
    const requestBody = { observaciones } as PatchTramRegistroObservaciones;
    return this.http.patch(`${this.apiUrl}/rechazar/${solicitudId}`, requestBody, { responseType: 'text' });
  }

  getSolicitudByTipoPQRSD(startDate:string, endDate:string): Observable<IGetSolicitudesPorTipoPqrsd[]> {
    const url = `${this.apiUrl}/dashboard/por-tipo-pqrsd`;
    const params: QueryParam[] = [
      {key:'startDate', value: startDate},  {key: 'endDate', value: endDate}
    ];
    return this.http.get<IGetSolicitudesPorTipoPqrsd[]>(Utils.createQueryParams(url, params));
  }

  getSolicitudesGlobalesByRangoFecha(startDate: string, endDate: string): Observable<IGetSolicitudesGlobales[]> {
    const url = `${this.apiUrl}/dashboard/pqrsd-globales`;
    const params: QueryParam[] = [
      {key:'startDate', value: startDate},  {key: 'endDate', value: endDate}
    ];
    return this.http.get<IGetSolicitudesGlobales[]>(Utils.createQueryParams(url, params));
  }

  getSolicitudesByMesByRangoFecha(startDate: string, endDate: string) : Observable<IGetSolicitudesByMes[]> {
    const url = `${this.apiUrl}/dashboard/pqrsd-por-mes`;
    const params: QueryParam[] = [
      {key:'startDate', value: startDate},  {key: 'endDate', value: endDate}
    ];
    return this.http.get<IGetSolicitudesByMes[]>(Utils.createQueryParams(url, params));
  }

  getActividadesPendienteAsignacion(): Observable<IGetActividadesPendienteAsignacion[]> {
    return this.http.get<IGetActividadesPendienteAsignacion[]>(`${this.apiUrl}/dashboard/pendiente-asignacion`);
  }
}
